package com.devi3east.bashbuddy.auth.util

object RecoveryTokenStore {
    var token: String? = null
}